module.exports = __webpack_public_path__ + "static/media/iheart.77a67cba.jpg";